// extracted by mini-css-extract-plugin
export var infoSection = "_b-1";
export var infoSectionContainer = "_b-0";
export var infoSectionTitleRow = "_b-2";
export var multiLineInfo = "_b-4";
export var strong = "_b-3";